module.exports = __webpack_public_path__ + "642218716fadc52b9138b797e99a5c04.woff";